/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Open_PropertyInputs */

const cs_portals_open_property = /** @type {(inputs: Portals_Open_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít nemovitost`)
};

const en_portals_open_property = /** @type {(inputs: Portals_Open_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open property`)
};

/**
* | output |
* | --- |
* | "Open property" |
*
* @param {Portals_Open_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_open_property = /** @type {((inputs?: Portals_Open_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Open_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_open_property(inputs)
	return cs_portals_open_property(inputs)
});